import React, { useState } from "react";
import styled from "styled-components";
import CustomIcon from "../../../common/components/image/CustomIcon";
import { C2Text } from "../../../common/components/text/CustomText";
import { Divider, Padding } from "../../../common/components/CommonBaseComponents";
import { Theme } from "../../../common/Theme";
import PrimaryButton from "../../../common/components/button/PrimaryButton";

const StoreLocationModalInputCard = ({
    address,
    setAddress,
    latitude,
    setLongitude,
    longitude,
    setLatitude,
    zipCode,
    setZipCode,
    onSearch,
}) => {
    const [isMinimal, setIsMinimal] = useState(false);

    return (
        <Card>
            <Padding padding={"12px"}>
                <Header $isMinimal={isMinimal}>
                    <C2Text fontWeight={"600"}>Address</C2Text>
                    <CustomIcon
                        iconName={"minimalize_button"}
                        size={"32px"}
                        onClick={() => setIsMinimal(!isMinimal)}
                        cursor={"pointer"}
                    />
                </Header>
                {!isMinimal && (
                    <InputGroup>
                        <MainInput
                            placeholder="Please enter the Address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                        />

                        <CoordinateRow>
                            <Label>Latitude</Label>
                            <Divider orientation={"vertical"} height={"16px"} marginLeft={"15px"} marginRight={"8px"} />
                            <CoordinateInput
                                defaultValue={latitude}
                                value={latitude}
                                onChange={(e) => setLatitude(e.target.value)}
                            />
                        </CoordinateRow>

                        <CoordinateRow>
                            <Label>longitude</Label>
                            <Divider orientation={"vertical"} height={"12px"} marginLeft={"15px"} marginRight={"8px"} />
                            <CoordinateInput
                                defaultValue={longitude}
                                value={longitude}
                                onChange={(e) => setLongitude(e.target.value)}
                            />
                        </CoordinateRow>

                        <CoordinateRow>
                            <Label>Zip Code</Label>
                            <Divider orientation={"vertical"} height={"12px"} marginLeft={"15px"} marginRight={"8px"} />
                            <CoordinateInput
                                defaultValue={zipCode}
                                value={zipCode}
                                onChange={(e) => setZipCode(e.target.value)}
                            />
                        </CoordinateRow>
                    </InputGroup>
                )}
            </Padding>
            {!isMinimal && (
                <Footer>
                    <Padding padding={"14px 12px"}>
                        <PrimaryButton icon={"search_white"} text={"Search"} onClick={onSearch} />
                    </Padding>
                </Footer>
            )}
        </Card>
    );
};

// --- Styled Components ---

const Card = styled.div`
    width: 420px;
    background: ${Theme.color.white};
    border-radius: 20px;
    //padding: 12px;
    box-shadow: 0 10px 25px ${Theme.color.black_006};
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    //margin-bottom: 24px;
    margin-bottom: ${({ $isMinimal }) => ($isMinimal ? "6px" : "24px")};
`;

const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const BaseInputStyle = `
  background: ${Theme.color.white};
  border: 1px solid ${Theme.color.gray200};
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 13px;
  color: ${Theme.color.zinc850};
  outline: none;
  
  &::placeholder {
    color: ${Theme.color.gray500};
  }
`;

const MainInput = styled.input`
    ${BaseInputStyle}
    width: 100%;
    box-sizing: border-box;
`;

const CoordinateRow = styled.div`
    ${BaseInputStyle}
    display: flex;
    align-items: center;
`;

const Label = styled.span`
    color: ${Theme.color.gray500};
    width: 80px;
    font-size: 13px;
`;

const CoordinateInput = styled.input`
    border: none;
    background: transparent;
    font-size: 15px;
    color: ${Theme.color.zinc850};
    width: 100%;
    outline: none;
`;

const Footer = styled.div`
    border-top: 1px solid #f0f3f6;
    padding-top: 20px;
    display: flex;
    justify-content: flex-end;
`;

export default StoreLocationModalInputCard;
